import { MCDANIEL_NAME } from "constants/settings.constants";

export interface GeoEntitlement {
  hasGeology: boolean;
  has3dGeoModel: boolean;
  geoPlays: string[];
}

/**
 * Mirrors EVA.ThreeDvSvc `MeshDataProcessingService.IsMcDanSource`: a blank source
 * and "McDaniel" in any case are both the EVA Research source.
 */
export function isEvaResearchSource(modelSource?: string): boolean {
  const source = modelSource?.trim();
  return !source || source.toLowerCase() === MCDANIEL_NAME.toLowerCase();
}

/**
 * EVA-148: whether the Geology/3D tier still covers a EVA Research
 * job. Callers branch on `isEvaResearchSource` first; a named-source job is gated by its
 * model's access list instead, so it is never passed here.
 */
export function isEvaResearchJobEntitled(
  job: { plays?: string[] },
  { hasGeology, has3dGeoModel, geoPlays }: GeoEntitlement
): boolean {
  // Empty plays fall back to the any-play rule: a Geology-only creator gets no stamp.
  if (job.plays?.length) {
    return job.plays.some((play) => geoPlays.includes(play));
  }
  return hasGeology || has3dGeoModel;
}

/**
 * EVA-360: whether a listed job may be offered. A named source is gated by the
 * server and its model's access list; an EVA Research job also needs the tier, which stays
 * checked here so the UI is right whichever side deploys first.
 */
export function isGeoJobAllowed(
  job: { modelSource?: string; plays?: string[] },
  entitlement: GeoEntitlement
): boolean {
  return (
    !isEvaResearchSource(job.modelSource) || isEvaResearchJobEntitled(job, entitlement)
  );
}
